import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "property-row" }
const _hoisted_2 = { class: "property-row-text" }
const _hoisted_3 = { class: "property-row-head" }
const _hoisted_4 = { class: "property-row-name text-subtitle-1" }
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "property-row-description text-body-2 text-medium-emphasis" }
const _hoisted_8 = {
  key: 0,
  class: "property-row-options"
}
const _hoisted_9 = {
  key: 2,
  class: "property-row-code"
}
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "text-medium-emphasis text-no-wrap" }
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "ontos-code text-truncate" }
const _hoisted_15 = { class: "text-medium-emphasis text-no-wrap" }
const _hoisted_16 = { class: "ontos-code text-truncate" }
const _hoisted_17 = {
  key: 0,
  class: "property-row-actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_ontos_colored_value = _resolveComponent("ontos-colored-value")!
  const _component_ontos_property_marks = _resolveComponent("ontos-property-marks")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_ontos_action_group = _resolveComponent("ontos-action-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_avatar, {
      size: "32",
      color: "primary",
      variant: "tonal",
      class: "property-row-icon"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, { size: "small" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.face.icon), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.face.name), 1),
        _createElementVNode("span", {
          class: "ontos-code text-caption text-medium-emphasis",
          title: _ctx.$tt('alias-url')
        }, _toDisplayString(_ctx.face.alias), 9, _hoisted_5),
        (_ctx.face.formulaName)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "ontos-code text-caption text-medium-emphasis",
              title: _ctx.$tt('formula-name')
            }, _toDisplayString(_ctx.face.formulaName), 9, _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.face.description), 1),
      (_ctx.face.options.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.face.options, (option) => {
              return (_openBlock(), _createBlock(_component_ontos_colored_value, {
                key: option.id,
                option: option,
                form: "chip"
              }, null, 8, ["option"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (!_ctx.marksBeside && _ctx.face.marks.length)
        ? (_openBlock(), _createBlock(_component_ontos_property_marks, {
            key: 1,
            marks: _ctx.face.marks,
            class: "property-row-marks"
          }, null, 8, ["marks"]))
        : _createCommentVNode("", true),
      (_ctx.face.formula)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_v_icon, {
              size: "x-small",
              class: "text-medium-emphasis"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-function-variant", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("code", {
              class: "ontos-code text-truncate",
              title: _ctx.face.formula
            }, _toDisplayString(_ctx.face.formula), 9, _hoisted_10),
            (_ctx.face.computedWhen)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$tt('pair.when')), 1),
                  _createElementVNode("code", {
                    class: "ontos-code text-truncate",
                    title: _ctx.face.computedWhen
                  }, _toDisplayString(_ctx.face.computedWhen), 9, _hoisted_12)
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.face.rules, (rule, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "property-row-code",
          title: rule.message
        }, [
          _createVNode(_component_v_icon, {
            size: "x-small",
            class: "text-medium-emphasis"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("mdi-check-decagram", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("code", _hoisted_14, _toDisplayString(rule.rule), 1)
        ], 8, _hoisted_13))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.face.conditions, (condition) => {
        return (_openBlock(), _createElementBlock("div", {
          key: condition.key,
          class: "property-row-code"
        }, [
          _createVNode(_component_v_icon, {
            size: "x-small",
            class: "text-medium-emphasis"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(condition.icon), 1)
            ]),
            _: 2
          }, 1024),
          _createElementVNode("span", _hoisted_15, _toDisplayString(condition.label), 1),
          _createElementVNode("code", _hoisted_16, _toDisplayString(condition.formula), 1)
        ]))
      }), 128))
    ]),
    (_ctx.canWrite || (_ctx.marksBeside && _ctx.face.marks.length))
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          (_ctx.marksBeside && _ctx.face.marks.length)
            ? (_openBlock(), _createBlock(_component_ontos_property_marks, {
                key: 0,
                marks: _ctx.face.marks
              }, null, 8, ["marks"]))
            : _createCommentVNode("", true),
          (_ctx.canWrite)
            ? (_openBlock(), _createBlock(_component_ontos_action_group, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    icon: "",
                    title: _ctx.$tt('edit'),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('edit', _ctx.property)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "small" }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode("mdi-pencil", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    icon: "",
                    color: "error",
                    title: _ctx.$tt('delete'),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('delete', _ctx.property)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "small" }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode("mdi-delete", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.canWrite)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 2,
                class: "ontos-grip text-medium-emphasis",
                title: _ctx.$tt('property-reorder')
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("mdi-drag", -1)
                ]))]),
                _: 1
              }, 8, ["title"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}